import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { chunk, isEmpty } from 'lodash';
import { Button } from '../styles/Button.styled';
import {
  DwtcVirtualAssetsLicensedActivitiesWrapper,
  DwtcVirtualAssetsLicensedActivitiesContainer,
  DwtcVirtualAssetsLicensedActivitiesHeaderWrapper,
  DwtcVirtualAssetsLicensedActivitiesHeader,
  DwtcVirtualAssetsLicensedActivitiesTitle,
  DwtcVirtualAssetsLicensedActivitiesText,
  DwtcVirtualAssetsLicensedActivitiesBody,
  DwtcVirtualAssetsLicensedActivitiesFirstRow,
  DwtcVirtualAssetsLicensedActivitiesSecondRow,
  DwtcVirtualAssetsLicensedActivitiesLists,
  DwtcVirtualAssetsLicensedActivitiesListImage,
  DwtcVirtualAssetsLicensedActivitiesListTitle,
  DwtcVirtualAssetsLicensedActivitiesButton,
} from '../styles/DwtcVirtualAssetsLicensedActivities.styled';

export default function DwtcVirtualAssetsLicensedActivities({ data, dir }) {
  const { contentTypeAlias, title, text, link, dwtcVirtualAssetsLicensedActivityList } = data;
  const chunkedArr = chunk(dwtcVirtualAssetsLicensedActivityList, 4);
  return (
    <DwtcVirtualAssetsLicensedActivitiesWrapper id={contentTypeAlias}>
      <DwtcVirtualAssetsLicensedActivitiesContainer>
        <DwtcVirtualAssetsLicensedActivitiesHeaderWrapper>
          <DwtcVirtualAssetsLicensedActivitiesHeader>
            <DwtcVirtualAssetsLicensedActivitiesTitle>
              {title}
            </DwtcVirtualAssetsLicensedActivitiesTitle>
            <DwtcVirtualAssetsLicensedActivitiesText>
              {text}
            </DwtcVirtualAssetsLicensedActivitiesText>
          </DwtcVirtualAssetsLicensedActivitiesHeader>
        </DwtcVirtualAssetsLicensedActivitiesHeaderWrapper>
        <DwtcVirtualAssetsLicensedActivitiesBody>
          <DwtcVirtualAssetsLicensedActivitiesFirstRow className="first_row">
            {isEmpty(chunkedArr[0]) ||
              chunkedArr[0].map((item, index) => (
                <DwtcVirtualAssetsLicensedActivitiesLists className="activities_lists" key={index}>
                  <DwtcVirtualAssetsLicensedActivitiesListImage>
                    {isEmpty(item.content.image) || (
                      <LazyLoadImage src={item.content.image.url} alt={item.content.title} />
                    )}
                  </DwtcVirtualAssetsLicensedActivitiesListImage>
                  <DwtcVirtualAssetsLicensedActivitiesListTitle>
                    <h2>{item.content.title.split(' | ')[0]}</h2>
                    <p>{item.content.title.split(' | ')[1]}</p>
                  </DwtcVirtualAssetsLicensedActivitiesListTitle>
                </DwtcVirtualAssetsLicensedActivitiesLists>
              ))}
          </DwtcVirtualAssetsLicensedActivitiesFirstRow>
          <DwtcVirtualAssetsLicensedActivitiesSecondRow>
            {isEmpty(chunkedArr[1]) ||
              chunkedArr[1].map((item, index) => (
                <DwtcVirtualAssetsLicensedActivitiesLists key={index}>
                  <DwtcVirtualAssetsLicensedActivitiesListImage>
                    {isEmpty(item.content.image) || (
                      <LazyLoadImage src={item.content.image.url} alt={item.content.title} />
                    )}
                  </DwtcVirtualAssetsLicensedActivitiesListImage>
                  <DwtcVirtualAssetsLicensedActivitiesListTitle>
                    <h2>{item.content.title.split(' | ')[0]}</h2>
                    <p>{item.content.title.split(' | ')[1]}</p>
                  </DwtcVirtualAssetsLicensedActivitiesListTitle>
                </DwtcVirtualAssetsLicensedActivitiesLists>
              ))}
          </DwtcVirtualAssetsLicensedActivitiesSecondRow>
          <DwtcVirtualAssetsLicensedActivitiesButton>
            <Button dir={dir} stylevariant="redSecondary" to={link.url} target="_blank">
              {link.name}
            </Button>
          </DwtcVirtualAssetsLicensedActivitiesButton>
        </DwtcVirtualAssetsLicensedActivitiesBody>
      </DwtcVirtualAssetsLicensedActivitiesContainer>
    </DwtcVirtualAssetsLicensedActivitiesWrapper>
  );
}
